import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "sonner";
import LoginPage from "@/pages/LoginPage";
import AuthCallback from "@/pages/AuthCallback";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import GoalPage from "@/pages/GoalPage";
import ProjectPage from "@/pages/ProjectPage";
import TaskPage from "@/pages/TaskPage";
import FlatView from "@/pages/FlatView";
import WeeklyRoster from "@/pages/WeeklyRoster";
import PeoplePage from "@/pages/PeoplePage";
import AnalyticsPage from "@/pages/AnalyticsPage";
import DailyRoster from "@/pages/DailyRoster";
import RosterImport from "@/pages/RosterImport";
import AllProjects from "@/pages/AllProjects";
import AdminPanel from "@/pages/AdminPanel";
import Timeline from "@/pages/Timeline";
import HabitTracker from "@/pages/HabitTracker";
import ApiPage from "@/pages/ApiPage";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen bg-[#F9F6F0]">
        <p className="text-[#5A5549] font-['Cormorant_Garamond'] text-2xl italic" data-testid="loading-text">
          Opening the codex...
        </p>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" />;
  return children;
}

function AppRouter() {
  const location = useLocation();
  // CRITICAL: Check URL fragment for session_id synchronously during render
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="goals/:goalId" element={<GoalPage />} />
        <Route path="projects/:projectId" element={<ProjectPage />} />
        <Route path="tasks/:taskId" element={<TaskPage />} />
        <Route path="flat-view" element={<FlatView />} />
        <Route path="all-projects" element={<AllProjects />} />
        <Route path="timeline" element={<Timeline />} />
        <Route path="weekly-roster" element={<WeeklyRoster />} />
        <Route path="daily-roster" element={<DailyRoster />} />
        <Route path="roster-import" element={<RosterImport />} />
        <Route path="people" element={<PeoplePage />} />
        <Route path="analytics" element={<AnalyticsPage />} />
        <Route path="habits" element={<HabitTracker />} />
        <Route path="api" element={<ApiPage />} />
        <Route path="admin" element={<AdminPanel />} />
      </Route>
    </Routes>
  );
}

import { ConfirmProvider } from "@/components/ConfirmDialog";

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ConfirmProvider>
          <AppRouter />
        </ConfirmProvider>
        <Toaster
          theme="light"
          position="top-right"
          richColors
          toastOptions={{
            style: {
              fontFamily: "'Manrope', sans-serif",
              borderRadius: "2px",
              border: "1px solid #E5DEC9",
            },
          }}
        />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
